import { Box } from "theme-ui";

export default function ArrowRightIcon(props) {
  return (
    <Box
      as="svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 8C0.223858 8 0 8.22386 0 8.5C0 8.77614 0.223858 9 0.5 9V8ZM16.5 9C16.7761 9 17 8.77614 17 8.5C17 8.22386 16.7761 8 16.5 8V9ZM0.5 9H16.5V8H0.5V9Z"
        fill="black"
      />
      <path
        d="M8.14645 16.1464C7.95118 16.3417 7.95118 16.6583 8.14645 16.8536C8.34171 17.0488 8.65829 17.0488 8.85355 16.8536L8.14645 16.1464ZM16.5 8.5L16.8536 8.85355L17.2071 8.5L16.8536 8.14645L16.5 8.5ZM8.85355 0.146447C8.65829 -0.0488155 8.34171 -0.0488155 8.14645 0.146447C7.95118 0.341709 7.95118 0.658291 8.14645 0.853553L8.85355 0.146447ZM8.85355 16.8536L16.8536 8.85355L16.1464 8.14645L8.14645 16.1464L8.85355 16.8536ZM16.8536 8.14645L8.85355 0.146447L8.14645 0.853553L16.1464 8.85355L16.8536 8.14645Z"
        fill="black"
      />
    </Box>
  );
}
